import { ClarionButtonLink } from '../clarion/ClarionButtonLink';
import { ClarionNonIdealState } from '../clarion/ClarionNonIdealState';

export function Component() {
  return (
    <ClarionNonIdealState
      className="py-8"
      title="404 Page Not Found"
      description="Sorry, the page you requested could not be found."
      icon="error"
      action={
        <ClarionButtonLink href="/" intent="primary" size="large">
          Go Home
        </ClarionButtonLink>
      }
    />
  );
}
